module.exports = __webpack_public_path__ + "img/329.936195e1.png";